import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { serverUrl } from "src/app/serverUrl";

@Injectable({
  providedIn: "root",
})
export class BlockchainService {
  constructor(private httpClient: HttpClient) {}

  getAllAssets(): Observable<any> {
    return this.httpClient.post<any>(serverUrl + "open/getAllAsset", {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
      responseType: "text" as "json",
    });
  }

  getAssetById(id: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("id", id);
    return this.httpClient.post<any>(serverUrl + "open/getAsset", queryParams, {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
      // responseType: "text" as "json",
    });
  }

  createAsset(doc: any, source: any, type: any, metadata: any, ext: any, fileName: any): Observable<any> {
    let queryParams = new HttpParams();
    // formData.append("doc", doc);
    queryParams = queryParams.append("source", source);
    queryParams = queryParams.append("type", type);
    queryParams = queryParams.append("metadata", metadata);

    queryParams = queryParams.append("imageString", doc);
    queryParams = queryParams.append("ext", ext);
    queryParams = queryParams.append("fileName", fileName);
    // let body = {
    //   doc: doc,
    //   source: source,
    //   type: type,
    //   metadata: metadata,
    // };
    return this.httpClient
      .post<any>(serverUrl + "open/createAssetV1", queryParams, {
        headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
        // .set("Content-Type", "multipart/form-data"),
        responseType: "text" as "json",
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        }),
        catchError((err) => {
          return of(err);
        })
      );
  }
}
